// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorContent_wrapper__bCAIo","title":"ErrorContent_title__b_S7J","image-wrapper":"ErrorContent_image-wrapper__6gx11","message":"ErrorContent_message__Nv38U"};